import { render, staticRenderFns } from "./TicketList.vue?vue&type=template&id=2e8fe76c&scoped=true"
import script from "./TicketList.vue?vue&type=script&lang=js"
export * from "./TicketList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8fe76c",
  null
  
)

export default component.exports